import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/stuart-parsons.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Stuart Parsons" keywords={[]} />
    <div>
      <div id="main" role="main">
        {' '}
        <div id="content" style={{ display: 'inline-block' }}>
          <h1 className="page-title">Stuart Parsons</h1>
          <div>
            <img
              src={Image}
              title="stuart-parsons"
              width={200}
              height={245}
              className="alignleft size-full wp-image-357"
              style={{ float: 'left' }}
            />
            <p />
            <p>
              Stuart Parsons is a Senior Associate with Gómez &amp; Associates
              as wells as the founder of HumanZoo International Consulting, a
              global consulting firm specializing in the identification and
              development of Human Potential within organizations. He is also a
              Senior Faculty member of Global Markets at the world renowned
              Center for Creative Leadership (CCL) in Colorado Springs. Stuart’s
              expertise lies in his ability to build strategic alignment and
              unity within business teams, while simultaneously identifying and
              facilitating the emotional commitment that fuels execution.
            </p>
            <p>
              Stuart is also a personal coach to hi-potential employees of
              several global companies and has spent in excess of 10 years as a
              team and organizational development consultant specializing in
              creating custom designed programs that develop leadership skills
              and high performance teams. He has extensive experience in
              management including corporate governance, finance, strategic
              planning, human resources and business development with
              Australian, North American, European, and Asia Pacific
              corporations.{' '}
            </p>
            <p>
              Until 2003, he was CEO of the Illawarra Regional Development
              Board, a joint public/ private funded economic development agency
              in Sydney, Australia, his hometown. Stuart has vast industry
              experience and his work has ranged across the fields of education,
              economic development and government to a large diverse portfolio
              of global companies in the financial, automotive, aeronautical,
              health, IT and mining sectors. He has worked with the UBS Global
              Leadership Development program in Hong Kong, London, Zurich, and
              New York and has been faculty for executive education at the
              University of Southern California’s Marshall School of Business –
              International Business, Education &amp; Research (IBEAR) program
              as well as at Dartmouth College in the Tuck School’s Executive
              Education Program.{' '}
            </p>
            <p>
              He designed and delivered the Duke Fuqua School of Business’
              Integrative Leadership Experience MBA program from 2003 to 2006.
              He also worked annually on the PriceWaterhouseCoopers’ New Partner
              Program and PwC’s Quality Lens and University 2 programs. Other
              clients include the National Security Agency (NSA), NCR, BAE
              Systems, Merck Pharmaceuticals, Petroleum Geo-Services (PGS) and
              the global mining company Anglo American. He has also designed and
              delivered global programs as a member of Duke Corporate Educations
              – Global Learning Resource Network (GLRN). As Senior Faculty at
              CCL he is Lead faculty for global custom clients MARS, IMC and
              Sauer-Danfoss.{' '}
            </p>
            <p>
              As coach to executives and hi-potential personnel, his work
              frequently involves the integration of assessment and behavioral
              feedback with developmental planning. He works with a compendium
              of feedback tools and processes. Stuart has been a feedback coach
              to global Anglo American high-potential leaders and has designed
              and delivered multiyear individual and team coaching assignments
              with the McKesson Provider Technologies Legal Counsel as well as
              coach to Waste Management Leaders as a member of the Breakthrough
              Performance Leadership (BPL) coaching team, a multiyear, multi
              layered organizational change program.
            </p>
            <p>
              Originally trained as a Chef prior to studying Accounting and
              Finance, Stuart then extended his academic studies to include a
              Bachelor Degree in the Business Management and Business Psychology
              and an MBA in Public Sector Management. He is qualified to
              administer the Myers Briggs Type Indicator (MBTI) and is certified
              in the use of DiSC and Gallups Q12 Engagement Survey.{' '}
            </p>
            <p>
              Stuart is an avid yachtsman and has competed in many well-known
              short and long distance offshore yachting races around the globe,
              as both crew and Captain. He is a permanent resident in the U.S.
              and has the unique benefit of holding both Australian and British
              passports which support his passion to work with individuals and
              business on a Global level. Stuart, his wife Lacey and dog Lolly
              live in Colorado Springs.{' '}
            </p>
            <p>
              Phone: 970.209.1121 | Email:{' '}
              <a
                href="mailto:stuart@gomezandassociates.com"
                alt="Email Stuart Parsons"
              >
                stuart@gomezandassociates.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <footer>
        <div id="footer-content">
          <ul id="navigation-footer">
            <li className="page_item page-item-4">
              <a href="http://gomezandassociates.com/">Who We Are</a>
            </li>
            <li className="page_item page-item-121">
              <a href="http://gomezandassociates.com/what-we-do">What We Do</a>
            </li>
            <li className="page_item page-item-19">
              <a href="http://gomezandassociates.com/our-clients">
                Our Clients
              </a>
            </li>
            <li className="page_item page-item-21">
              <a href="http://gomezandassociates.com/work-projects">
                Work Projects
              </a>
            </li>
            <li className="page_item page-item-23 current_page_ancestor current_page_parent">
              <a href="http://gomezandassociates.com/our-associates">
                Our Associates
              </a>
            </li>
            <li className="page_item page-item-15">
              <a href="http://gomezandassociates.com/contact-us">Contact Us</a>
            </li>
          </ul>
          <div id="footer-contact">
            <img
              className="float-left"
              src="./Stuart Parsons_files/logosm.jpg"
              height={55}
              alt="Gómez & Associates Logo"
            />
            <ul id="footer-contact-info">
              <li>14 E. Jefferson Street,</li>
              <li>Colorado Springs,</li>
              <li>CO 80907</li>
              <li>719.447.4841 (O)</li>
              <li>719.659.0808 (M)</li>
              <li>
                <a className="white" href="mailto:info@gomezandassociates.com">
                  info@gomezandassociates.com
                </a>
              </li>
            </ul>
          </div>
          <div id="bottom-statement">
            Gómez &amp; Associates - The Leading Edge for Executive Teams
          </div>
        </div>
      </footer>
    </div>
  </Layout>
)

export default IndexPage
